import { Box, IconButton, Modal, Typography } from "@mui/material";
import { Close, InfoOutlined, Sick } from "@mui/icons-material";

interface JustificationModalProps {
  open: boolean;
  onClose: () => void;
  note?: string;
  status?: string;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  textAlign: "center" as "center",
};

export function JustificationModal({
  open,
  onClose,
  note,
  status,
}: JustificationModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-justificativa"
      aria-describedby="modal-justificativa-descricao"
    >
      <Box sx={style}>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
        {status === "stopped" ? (
          <Sick sx={{ fontSize: 40, color: "primary.main", mb: 2 }} />
        ) : (
          <InfoOutlined sx={{ fontSize: 40, color: "primary.main", mb: 2 }} />
        )}

        <Typography
          id="modal-justificativa"
          variant="h6"
          component="h2"
          gutterBottom
        >
          {status === "stopped"
            ? "Motivo da interrupção do medicamento"
            : "Observação do paciente"}
        </Typography>
        <Typography id="modal-justificativa-descricao" sx={{ mt: 2 }}>
          {note || "Não há justificativa registrada."}
        </Typography>
      </Box>
    </Modal>
  );
}
